import {ManagedCampaigns} from '@/content/pages/managed-campaigns/index';

export default {
  icon: require('@/assets/icons/services/content_creation_icon.png'),
  title: 'Online Reputation Management',
  url: '/services/online-reputation-management',
  meta: {
    title: '',
    // TODO
  },
} as ManagedCampaigns;
